var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSorting1 = function SvgSorting1(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 20,
    viewBox: "0 0 19.5 19.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.716.227a.7.7 0 0 0-1.032 0l-4.5 4.91a.7.7 0 1 0 1.032.945L4.5 2.5v16.2a.7.7 0 1 0 1.4 0V2.5l3.284 3.582a.7.7 0 1 0 1.032-.946zm7.968 18.946a.7.7 0 0 0 1.032 0l4.5-4.91a.7.7 0 0 0-1.032-.945L14.9 16.9V.7a.7.7 0 0 0-1.4 0v16.2l-3.284-3.582a.7.7 0 0 0-1.032.946z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSorting1);
export default ForwardRef;